import {defineStore} from "pinia";

const BASE_URL = import.meta.env.VITE_API_BASE_URL || window.location.origin;

export const useMaintenanceStore = defineStore('maintenanceStore', {
    state: () => ({
        isMaintenance: false,
        lastChecked: null,
        retryCount: 0,
        maxRetries: 3
    }),
    actions: {
        setMaintenance(status) {
            this.isMaintenance = status;
            this.lastChecked = new Date();
        },
        resetMaintenance() {
            this.isMaintenance = false;
            this.lastChecked = null;
            this.retryCount = 0;
        },
        async checkHealth() {
            try {
                const res = await fetch(`${BASE_URL}/api/v1/categories`, {
                    method: 'GET',
                    signal: AbortSignal.timeout(5000),
                });
                if (res.ok || res.status === 404) {
                    this.resetMaintenance();
                    return true;
                }
                return false;
            } catch {
                return false;
            }
        },
    }
});
